<template>
  <div
    :class="`dropdown ${dropdownIsOpen && 'dropdown--is-open'}`"
    @click="handleClick"
  >
    <div class="dropdown__button">
      <svgicon name="world" />
      <div>{{ $t(`languageSwitcher.${this.$i18n.locale}`) }}</div>
    </div>
    <div class="dropdown__content">
      <div
        class="dropdown__item"
        v-for="locale in availableLocales"
        :key="locale"
      >
        <div class="dropdown__item">
          <router-link
            :to="localizedLink('home', locale)"
            :class="[
              'dropdown__link',
              { 'dropdown__link--active': locale === $i18n.locale }
            ]"
          >
            {{ $t(`languageSwitcher.${locale}`) }}
            <svgicon name="check" v-if="locale === $i18n.locale" />
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { localizedLink } from "@/mixins";
export default {
  mixins: [localizedLink],
  props: {
    dropdownIsOpen: Boolean
  },
  computed: {
    availableLocales() {
      return this.$i18n.availableLocales;
    }
  },
  methods: {
    handleClick() {
      this.$emit("handleClick");
    }
  }
};
</script>

<style lang="scss" scoped>
.dropdown {
  position: relative;
}

.dropdown--is-open {
  .dropdown__content {
    display: block;
  }
}

.dropdown__button {
  display: flex;
  align-items: center;
  align-content: center;
  font-weight: 700;
  color: $--color-white;
  cursor: pointer;
  .svg-icon {
    margin-right: 10px;
    width: 20px;
    height: 20px;
  }
}

.dropdown__content {
  display: none;
  position: absolute;
  left: 30px;
  bottom: calc(100% + 9px);
  padding: 15px;
  background-color: $--color-white;
  box-shadow: 0px 10px 15px rgba(88, 87, 90, 0.3);
  border-radius: 5px;
}

.dropdown__link {
  padding-top: 7px;
  padding-bottom: 7px;
  font-size: rem(14);
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: $--color-text-dark;
  &:hover {
    color: $--color-purple-hover;
  }
}

.dropdown__link--active {
  font-weight: 700;

  .svg-icon {
    margin-left: 15px;
    width: 12px;
    height: 12px;
    ::v-deep * {
      fill: $--color-landing-primary;
      stroke: $--color-landing-primary;
    }
  }
}
</style>
